import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=0158fd0a&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style0 from "./Header.vue?vue&type=style&index=0&id=0158fd0a&prod&lang=scss&scoped=true"
import style1 from "./Header.vue?vue&type=style&index=1&id=0158fd0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0158fd0a",
  null
  
)

export default component.exports